export default __webpack_public_path__ + "static/pic5-12de17ab0525222624f9ef1f6389cb8d.webp";